import { render, staticRenderFns } from "./pr-desc-modal.vue?vue&type=template&id=1a7c6f28&"
import script from "./pr-desc-modal.vue?vue&type=script&lang=js&"
export * from "./pr-desc-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports